import { render } from "./AdminMacrodataRefinement.vue?vue&type=template&id=93d9f80c&scoped=true"
import script from "./AdminMacrodataRefinement.vue?vue&type=script&lang=js"
export * from "./AdminMacrodataRefinement.vue?vue&type=script&lang=js"

import "./AdminMacrodataRefinement.vue?vue&type=style&index=0&id=93d9f80c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93d9f80c"]])

export default __exports__